
import { defineComponent, PropType, ref, toRefs, watch } from 'vue';
import { get } from 'lodash-es';
import { formatTime } from '@toy/utils';
import { filters } from '@/core/plugins/filter';
import { IRequestConfig, IListItem } from './type.d';

export default defineComponent({
  props: {
    title: {
      type: String,
      default: '操作日志',
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
    request: {
      type: Function,
      default: () => {},
    },
    config: {
      type: Object as PropType<IRequestConfig>,
      default: () => ({}),
    },
    requestParams: {
      type: [Object, String],
    },
    isAscending: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { config } = toRefs(props);
    const list = ref<IListItem[]>([]);
    watch(() => props.modelValue, async (value: boolean) => {
      if (value) {
        const res = await props.request(props.requestParams);
        const { timeKey, userKey, contentKey, remarkKey, operateList = [] } = {
          timeKey: 'time',
          userKey: 'user',
          contentKey: 'content',
          remarkKey: 'remark',
          ...config.value,
        };
        list.value = get(res, config.value.listKey! || 'data')?.map((item: any) => {
          return {
            time: typeof (item[timeKey]) === 'number' ? formatTime(item[timeKey]) : item[timeKey],
            user: item[userKey],
            content: filters.getEnumLabel(operateList, item[contentKey]) || item[contentKey],
            remark: item[remarkKey] ?? '',
          };
        }) ?? [];
      }
    });

    const getColor = (idx: number) => {
      if (props.isAscending) {
        return idx === list.value.length - 1 ? '#4974F5' : '#cccccc';
      }
      return idx === 0 ? '#4974F5' : '#cccccc';
    };

    return {
      list,
      getColor,
    };
  },
});
